import { render, staticRenderFns } from "./HomepagePublish.vue?vue&type=template&id=b2296088&"
import script from "./HomepagePublish.vue?vue&type=script&lang=js&"
export * from "./HomepagePublish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports